export const DIST_LIGHT_YEAR = 63241.1 * 23.4117;

export const RADIUS_GALAXY = 50000*DIST_LIGHT_YEAR

export const ANGLE_ROT_WARP = 75 * (Math.PI / 180)

export const NEB_MAX_SPEED = 1.8e-10

export const NEB_MIN_SPEED = 5.9e-11

export const NEB_MAX_OFFSET = 3500 * DIST_LIGHT_YEAR

export const NEB_MIN_OFFSET = 1100 * DIST_LIGHT_YEAR

export const NEB_MAX_SIZE = 28000 * DIST_LIGHT_YEAR

export const NEB_MIN_SIZE = 13000 * DIST_LIGHT_YEAR

export const NEB_OPAQUE_MAX_SPEED = 1.5e-10

export const NEB_OPAQUE_MIN_SPEED = 2.9e-11

export const NEB_OPAQUE_MAX_OFFSET = 600 * DIST_LIGHT_YEAR

export const NEB_OPAQUE_MIN_OFFSET = 260 * DIST_LIGHT_YEAR

export const NEB_OPAQUE_MAX_SIZE = 8500 * DIST_LIGHT_YEAR

export const NEB_OPAQUE_MIN_SIZE = 3500 * DIST_LIGHT_YEAR

export const STARS_MAX_SPEED = 3.6e-10

export const STARS_MIN_SPEED = 4.7e-11

export const STARS_MAX_OFFSET = 4280 * DIST_LIGHT_YEAR

export const STARS_MIN_OFFSET = 326 * DIST_LIGHT_YEAR

export const STARS_INCLIN_SPEED = 1e-3

export const MAX_WARP_ANGLE = 11 * (Math.PI / 180); 
export const WAVE_SPEED = -1.2e-11

export const WAVE_START = RADIUS_GALAXY/3
export const INCLIN_GALAXY = -1.05068821

